import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getServiceRequest } from "../services/serviceRequests";

export const SERVICE_REQUEST_QUERY_KEY = "serviceRequest";

export const useServiceRequest = (serviceRequestId: string, enabled: boolean) =>
  useDataQuery(
    [SERVICE_REQUEST_QUERY_KEY, serviceRequestId],
    () => getServiceRequest(serviceRequestId),
    { enabled }
  );
